module.exports = __webpack_public_path__ + "img/friend.49f1ac9a.svg";